<template>
    <div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="收款申请" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm"
                                :rules="rules.searchForm">
                                <el-form-item label="收款编码">
                                    <el-input v-model="searchForm.re_invoice_code" placeholder="请填写收款编码"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="银行流水号">
                                    <el-input v-model="searchForm.num" placeholder="请填写银行流水号" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="收款类型">
                                    <el-select v-model="searchForm.searchType" placeholder="请选择收款类型"
                                        @change="changeSearchType" clearable>
                                        <el-option label="项目收款" value="1"></el-option>
                                        <el-option label="执行返点" value="2"></el-option>
                                    </el-select>
                                    <div v-if="!searchForm.searchType"
                                        style="position: absolute;line-height: 16px;color: #f56c6c;font-size: 12px;">
                                        请先选择收款类型</div>
                                </el-form-item>
                                <el-form-item :label="searchForm.searchType == 1 ? '项目编码' : '执行编码'"
                                    v-if="searchForm.searchType">
                                    <el-input placeholder="请输入搜索内容" v-model="searchForm.execute_code"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="所属客户" v-if="searchForm.searchType == 1">
                                    <el-select v-model="searchForm.customer_id" placeholder="请选择所属客户" clearable
                                        filterable remote reserve-keyword :remote-method="getSupplierSelect">
                                        <el-option v-for="item in options.supplier_id_options" :key="item.value"
                                            :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="所属供应商" v-if="searchForm.searchType == 2">
                                    <el-select v-model="searchForm.supplier_id" placeholder="请选择所属供应商" clearable
                                        filterable remote reserve-keyword :remote-method="getSupplierSelectDown">
                                        <el-option v-for="item in options.gong_id_options" :key="item.value"
                                            :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="审批人">
                                    <el-input v-model="searchForm.check_name" placeholder="可模糊搜索审批人"
                                        clearable></el-input>
                                </el-form-item>
                                <el-form-item label="申请人">
                                    <el-select v-model="searchForm.applicant_id" placeholder="请选择申请人" clearable
                                        filterable remote reserve-keyword :remote-method="getUserSelect">
                                        <el-option v-for="item in options.applicant_id_options" :key="item.value"
                                            :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="审批节点">
                                    <el-select v-model="searchForm.flow_step_id" placeholder="请选择审批类型" clearable>
                                        <el-option v-for="item in options.check_option" :key="item.id"
                                            :label="item.step_name" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="状态">
                                    <el-select v-model="searchForm.status" placeholder="请选择收款状态" clearable>
                                        <el-option v-for="item in options.status_options" :key="item.value"
                                            :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="申请时间">
                                    <el-date-picker v-model="searchForm.applicant_time" type="daterange"
                                        format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至"
                                        start-placeholder="开始日期" end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                                    <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;"
                                v-if="$parent.$parent.isAuthAction('admin/news/message/applyprojectcollection')">
                                <div>
                                    <el-button type="primary" size="mini" @click="addInvoiceOpen"
                                        v-if="$parent.$parent.isAuthAction('admin/news/message/applyprojectcollection')">收款申请</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table :data="tableData.data" style="width: 100%" border stripe ref="table"
                                    highlight-current-row @sort-change="sortChange" :height="tableHeight"
                                    v-loading="loading">
                                    <el-table-column prop="bank_statement_code" label="收款编码" min-width="200">
                                        <template slot-scope="scope">
                                            <el-link type="primary" style="font-size: 12px; text-decoration: underline;"
                                                :underline="false" @click="detail(scope.row)" target="_blank">{{
                                                    scope.row.bank_statement_code }}</el-link>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="type_txt" label="收款类型" min-width="100">
                                    </el-table-column>
                                    <el-table-column prop="customer_id_txt" label="所属客户/供应商" min-width="200">
                                    </el-table-column>
                                    <el-table-column prop="applicant_id_txt" label="申请人" width="100">
                                    </el-table-column>
                                    <el-table-column prop="receiving_id_txt" label="确认人" width="100">
                                        <template slot-scope="scope">
                                            {{ scope.row.receiving_id_txt ? scope.row.receiving_id_txt : '--' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="list" label="收款明细" width="100">
                                        <template slot-scope="scope">
                                            <el-popover placement="top-start" width="480" trigger="hover">
                                                <el-table :data="scope.row.list" height="350" style="width: 100%;"
                                                    border stripe highlight-current-row>
                                                    <el-table-column width="80" property="type"
                                                        label="关联类型"></el-table-column>
                                                    <el-table-column width="150" property="project_code"
                                                        label="项目编码"></el-table-column>
                                                    <el-table-column width="150" property="num"
                                                        label="银行流水"></el-table-column>
                                                    <el-table-column width="100" property="used_cost"
                                                        label="关联金额"></el-table-column>
                                                </el-table>
                                                <el-link type="primary" slot="reference" style="font-size: 12px;"
                                                    :underline="false">查看详情</el-link>
                                            </el-popover>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="remark" label="审批信息" min-width="200" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <p
                                                style="font-weight:bold;height: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                                审批人:&nbsp;&nbsp;&nbsp;&nbsp;{{ scope.row.check_name }}</p>
                                            <p style="font-weight:bold;">当前节点:&nbsp;{{ scope.row.check_rover }}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="remark" label="备注" show-overflow-tooltip min-width="150">
                                    </el-table-column>
                                    <el-table-column prop="applicant_time" label="申请时间" min-width="150">
                                    </el-table-column>
                                    <el-table-column fixed="right" prop="status_txt" align="center" label="状态"
                                        width="80">
                                        <template slot-scope="scope">
                                            <span style="font-weight: bold;">{{ scope.row.status_txt }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column fixed="right" label="操作"
                                        v-if="$parent.$parent.isAuthAction('admin/news/message/confirmprojectcollection') || $parent.$parent.isAuthAction('admin/news/message/delcollectioninfo') || $parent.$parent.isAuthAction('admin/news/message/editprojectcollection')"
                                        min-width="150">
                                        <template slot-scope="scope">
                                            <el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)"
                                                @click="editConfirmForm(scope.row)" type="text" :size="size"
                                                v-if="$parent.$parent.isAuthAction('admin/news/message/editprojectcollection')">编辑</el-button>
                                            <el-button :disabled="!(scope.row.status == 1)"
                                                @click="addConfirmForm(scope.row)" type="text" :size="size"
                                                v-if="$parent.$parent.isAuthAction('admin/news/message/confirmprojectcollection')">提交审批</el-button>
                                            <el-button
                                                :disabled="!(scope.row.status == 2 && scope.row.order_step && scope.row.order_step <= 1)"
                                                @click="returnMessage(scope.row)" type="text" :size="size"
                                                v-if="$parent.$parent.isAuthAction('admin/resources/resources/returnmessage_collectioncost')">撤回申请</el-button>
                                            <el-button :disabled="!(scope.row.status == 1 || scope.row.status == 3)"
                                                type="text" @click="handleDelete(scope.row)" :size="size"
                                                v-if="$parent.$parent.isAuthAction('admin/news/message/delcollectioninfo')">删除申请</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination background ref="pagination" @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange" :current-page="tableData.page | number"
                                    :page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
                                    layout="prev, pager, next, sizes, total" :total="tableData.total | number">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!--申请收款-->
        <el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl"
            :close-on-press-escape='false' :wrapperClosable='false' size="90%">
            <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
                v-loading="loading">
                <div class="drawer-header">
                    <div class="header-title">
                        <span>申请收款</span>
                        <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                    </div>
                </div>
                <div class="drawer-content">
                    <el-form-item label="类型" prop="type">
                        <el-radio-group v-model="addForm.type" @input="changeType">
                            <el-radio :label="1">项目收款</el-radio>
                            <el-radio :label="2">返点</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div v-if="addForm.type == 1">
                        <el-form-item label="客户" prop="supplier_id">
                            <el-select v-model="addForm.supplier_id" filterable remote placeholder="请选择客户" clearable
                                style='width: 100%;' @change="changeGetSupplier" :remote-method="getSupplierSelect">
                                <el-option v-for="item in options.supplier_id_options" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="项目" prop="project_ids" v-if="addForm.supplier_id">
                            <el-select v-model="addForm.project_ids" multiple filterable remote clearable
                                placeholder="可搜索项目名称" style='width: 100%;' @change="addExecuteIds"
                                :remote-method="getSupplier">
                                <el-option v-for="item in options.execute_ids_options" :key="item.value"
                                    :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <div style="padding-top: 8px; color: #F56C6C; font-size:13px;" v-if="execute_tips">
                                {{ execute_tips }}
                            </div>
                        </el-form-item>
                    </div>
                    <template v-if="addForm.type == 2">
                        <el-form-item label="供应商" prop="supplier_id">
                            <el-select v-model="addForm.supplier_id" filterable remote placeholder="请选择供应商" clearable
                                style='width: 100%;' @change="changeGetSupplierExecute"
                                :remote-method="getSupplierSelectDown">
                                <el-option v-for="item in options.gong_id_options" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="执行" prop="project_ids" v-if="addForm.supplier_id">
                            <el-select v-model="addForm.project_ids" multiple filterable remote clearable
                                placeholder="可搜索执行编码" style='width: 100%;' @change="addExecuteIds"
                                :remote-method="getSupplierExecute">
                                <el-option v-for="item in options.execute_ids_options" :key="item.value"
                                    :label="item.label" :value="item.value"></el-option>
                            </el-select>
                            <div style="padding-top: 8px; color: #F56C6C; font-size:13px;" v-if="execute_tips">
                                {{ execute_tips }}</div>
                        </el-form-item>
                    </template>
                    <el-row v-for="(item, index) in collection_array" :key="index" v-if="collection_array.length > 0">
                        <el-form-item style="margin-bottom: 0;">
                            <el-col :span="6">
                                <el-form-item label="明细编码:" label-width="78px">
                                    <el-input v-model="addForm.collection_array[index].project_code" clearable
                                        disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="名称:" label-width="78px">
                                    <el-input v-model="addForm.collection_array[index].name" clearable
                                        disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="银行流水:" :prop="`collection_array[${index}].bank_statement_id`"
                                    :rules="[{
                                        required: true, validator: (rule, value, callback) => {
                                            if (!value) {
                                                callback('请选择银行流水')
                                            } else {
                                                callback()
                                            }
                                        }, trigger: 'blur'
                                    }]">
                                    <el-select v-model="addForm.collection_array[index].bank_statement_id" filterable
                                        remote clearable placeholder="请输入【流水号/付款方/票面金额】搜索" style='width: 100%;'
                                        @change="getCost(index)" :remote-method="getInviocelrId">
                                        <el-option v-for="item in options.invioce_lr_id_options" :key="item.value"
                                            :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="使用金额:" :prop="`collection_array[${index}].cost`"
                                    :rules="[{ required: true, validator: validatorLrId, trigger: 'blur' }]">
                                    <el-input v-model="addForm.collection_array[index].cost"
                                        placeholder="请填写使用金额"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-row>
                    <el-form-item v-if="collection_array.length > 0 && addForm.collection_array[0].project_code">
                        <el-col :span="12" style="margin-right:10px">
                            <el-form-item label="申请收款金额合计:" label-width="135px">
                                <span>{{ returnCost() }}元</span>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="申请备注">
                        <el-input type="textarea" :rows="6" v-model="addForm.remark" placeholder="请填写申请备注"
                            clearable></el-input>
                    </el-form-item>
                </div>
                <div class="drawer-footer">
                    <el-button :disabled="addFormVisiableButton" type="primary" @click="addInvoice('SAVE')"
                        :size='size'>保存</el-button>
                    <el-button type="danger" :disabled="addFormVisiableButton" @click="addInvoice('SUBMIT')"
                        :size='size'>提交</el-button>
                    <el-button :size='size' @click="addFormVisiable = false">取消</el-button>
                </div>
            </el-form>
        </el-drawer>
    </div>
</template>
<script>
export default {
    props: ['info'],
    data () {
        return {
            addFormVisiableButton: false,
            addFormVisiable: false,
            editFormVisiable: false,
            loading: false,
            activeName: 'first',
            size: 'mini',
            options: {
                check_option: [],
                gong_id_options: [],
                status_options: [
                    {
                        value: 1,
                        label: '待提交'
                    }, {
                        value: 2,
                        label: '待审核'
                    }, {
                        value: 3,
                        label: '已驳回'
                    }, {
                        value: 4,
                        label: '正常'
                    }
                ],
                qr_status_options: [
                    {
                        value: 3,
                        label: '收款'
                    }, {
                        value: 2,
                        label: '驳回'
                    }
                ],
                invoice_type_options: [
                    {
                        value: 1,
                        label: '普票'
                    }, {
                        value: 2,
                        label: '专票'
                    }, {
                        value: 3,
                        label: '形式发票'
                    }
                ],
                invoice_status_options: [
                    {
                        value: 1,
                        label: '收款'
                    }, {
                        value: 2,
                        label: '开票'
                    }
                ],
                supplier_id_options: [],
                applicant_id_options: [],
                execute_ids_options: [],//执行下拉列表
                invioce_lr_id_options: []//发票录入下拉列表
            },
            searchForm: {
                re_invoice_code: '',
                check_name: '',
                flow_step_id: '',
                num: '',
                searchType: '',
                execute_code: '',
                customer_id: '',
                supplier_id: '',
                applicant_id: '',
                status: '',
                applicant_time: ''
            },
            resetSearch: {
                re_invoice_code: '',
                check_name: '',
                flow_step_id: '',
                num: '',
                searchType: '',
                execute_code: '',
                customer_id: '',
                supplier_id: '',
                applicant_id: '',
                status: '',
                applicant_time: ''
            },
            addForm: {
                type: 1,
                supplier_id: '',
                project_ids: [],
                collection_array: [{
                    project_id: '',
                    bank_statement_id: '',
                    cost: '',
                    project_code: ''
                }],
                remark: ''
            },
            confirmForm: {
                id: '',
                status: '',
                remark: ''
            },
            rules: {
                searchForm: {

                },
                addForm: {
                    'project_ids': [
                        { required: true, message: '请选择项目', trigger: ['change'] }
                    ]
                },
                confirmForm: {
                    'status': [
                        { required: true, message: '请选择状态', trigger: ['change'] }
                    ],
                    'remark': [
                        {
                            validator: (rule, value, callback) => {
                                if (!value && this.confirmForm.status == 2) {
                                    callback(new Error('请填写备注信息'));
                                } else {
                                    callback();
                                }
                            }, trigger: ['change', 'blur']
                        }
                    ],
                }
            },
            tableData: {
                total: 0,
                pagesize: 15,
                page: 1,
                data: []
            },
            collection_array: [],//发票信息集合
            execute_tips: ''//执行提示
        }
    },
    computed: {
        isSupper: function () {
            return this.info.views.isSupper
        },
        tableHeight: function () {
            return window.innerHeight - 320;
        }
    },
    watch: {

    },
    mounted: function () {
        //this.handleSearch(this.searchForm);
        this.getUserSelect()
        this.getCollectionCheckList();
    },
    methods: {
        getCollectionCheckList () {
            this.$api.get('/admin/resources/resources/getpaymentchecklist', { 'set_id': 8 }).then(res => {
                if (res.code === 0) {
                    this.options.check_option = res.data;
                }
            })
        },
        returnMessage (row) {
            this.$confirm('此操作将撤销该条申请重新提交, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                this.loading = true;
                this.$api.post('/admin/resources/resources/returnmessage_collectioncost', { data_id: row.id, log_id: row.log_id }).then(res => {
                    if (res.code === 0) {
                        this.$message({
                            showClose: true,
                            message: '该申请撤销成功！',
                            type: 'success'
                        });
                        this.handleSearch();
                    } else {
                        this.$message.error(res.msg);
                    }
                    this.loading = false
                })
            }.bind(this))
        },
        changeSearchType (val) {
            this.searchForm.execute_code = ''
            if (val == 1) {
                this.searchForm.supplier_id = ''
                this.getSupplierSelect()
            } else if (val == 2) {
                this.searchForm.customer_id = ''
                this.getSupplierSelectDown()
            }
        },
        returnCost () {
            return this.addForm.collection_array.reduce((acc, item) => acc + Number(item.cost), 0).toFixed(2)
        },
        handleSizeChange (pages) {
            this.tableData.pagesize = pages
            this.handleSearch(this.searchForm, 1);
        },
        changeType (val) {
            if (val == 1) {
                this.getSupplierSelect()
            } else {
                this.getSupplierSelectDown()
            }

            this.addForm.supplier_id = ''
            this.addForm.project_ids = []
            this.addForm.remark = ''
            this.collection_array = []
            this.execute_tips = ''
            // 获取发票录入下拉
            this.getInviocelrId()
        },
        getSupplierSelectDown (query, fun) {
            query = query ? query : '';
            this.$api.get('/admin/resources/resources/supldwn', { query: query }).then(res => {
                if (res.code === 0) {
                    this.options.gong_id_options = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
            if (typeof fun === 'function') {
                fun();
            }
        },
        getSupplierSelect (query, fun) {
            query = query ? query : '';
            this.$api.get('/admin/customers/customer/getcustomerselect', { query: query }).then(res => {
                if (res.code === 0) {
                    this.options.supplier_id_options = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
            if (typeof fun === 'function') {
                fun();
            }
        },
        getUserSelect (query) {
            query = query ? query : '';
            this.$api.post('/admin/users/user/getuserbydepartment', { query: query }).then(res => {
                if (res.code === 0) {
                    this.options.applicant_id_options = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleDelete (row) {
            this.$confirm('此操作将永久删除该条申请, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                this.loading = true;
                this.$api.delete('/admin/news/message/delcollectioninfo', { id: row.id }).then(res => {
                    if (res.code === 0) {
                        var data = this.tableData.data;
                        data.forEach(function (item, index) {
                            if (item.id == row.id) {
                                this.$delete(data, index);
                            }
                        }.bind(this));
                        this.$message({
                            showClose: true,
                            message: '该申请已成功删除！',
                            type: 'success'
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                    this.loading = false
                })
            }.bind(this))
        },
        validatorLrId (rule, value, callback) {
            let result = rule.field.match(/\[(.*?)\]/);
            let index = result[1]
            if (this.addForm.collection_array[index].bank_statement_id) {
                if (!value) {
                    callback('请填写使用金额')
                } else {
                    if (!isNaN(Number(value)) && value > 0) {
                        //实时验证可用票面金额-------发票录入
                        this.$api.post('/admin/news/message/collectionvalidate', { type: this.addForm.type, id: this.addForm.collection_array[index].bank_statement_id, collection_array: this.addForm.collection_array }).then(res => {
                            if (res.code === 0) {
                                if (res.data.maxCost < 0) {
                                    callback('已超出最大可使用金额')
                                } else {
                                    //获取当前index的发票录入id相同的对象的索引
                                    let val = this.addForm.collection_array[index].bank_statement_id
                                    let indices = [];
                                    for (let i = 0; i < this.addForm.collection_array.length; i++) {
                                        if (this.addForm.collection_array[i].bank_statement_id === val) {
                                            indices.push(i);
                                        }
                                    }
                                    for (let i = 0; i < indices.length; i++) {
                                        let newval = indices[i]
                                        //清楚所有相同索引的报错信息
                                        this.$nextTick(() => {
                                            this.$refs['addForm'].clearValidate(`collection_array[${newval}].cost`);
                                        });
                                    }
                                    callback()
                                }
                            } else {
                                this.$message.error(res.msg);
                            }
                        })

                    } else {
                        callback('使用金额必须为数字且必须大于0')
                    }
                }
            } else {
                callback('请先选择银行流水')
            }
        },
        handleSearch: function (params, page, prop, order) {
            this.loading = true;
            var param = Object.assign({}, params);
            param['page'] = page ? page : 1;
            param['pagesize'] = this.tableData.pagesize;
            param['prop'] = prop ? prop : 'id';
            param['order'] = order ? order : 'desc';
            this.$api.get('/admin/news/message/getcollectionlist', param).then(res => {
                if (res.code === 0) {
                    this.tableData = res.data;
                    this.$nextTick(() => {
                        if (this.$refs.table) {
                            this.$refs.table.doLayout();
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
                this.loading = false
            })
        },
        // 执行查询
        doSearch () {
            this.$refs['searchForm'].validate((valid) => {
                if (valid) {
                    this.handleSearch(this.searchForm)
                }
            })
        },
        // 重置
        reset () {
            this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
            this.doSearch();
        },
        // 排序
        sortChange (e) {
            var order;
            var prop = e.prop;
            if (e.order == 'ascending') {
                order = 'asc';
            } else if (e.order == 'descending') {
                order = 'desc';
            } else {
                prop = this.resetSearch.prop;
                order = this.resetSearch.order;
            }
            this.handleSearch(this.searchForm, 1, prop, order);
        },
        // 改变当前页 page
        handleCurrentChange (val) {
            this.handleSearch(this.searchForm, val);
        },
        //获取执行列表
        getSupplierExecute (query, fun, ids = []) {
            query = query || '';
            this.$api.get('/admin/customers/customer/getexecuteselect', { 'supplier_id': this.addForm.supplier_id, 'query': query, 'public_id': ids, 'status': 'applycollection' }).then(res => {
                if (res.code === 0) {
                    this.options.execute_ids_options = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
            if (typeof fun === 'function') {
                fun();
            }
        },
        changeGetSupplierExecute () {
            this.getSupplierExecute('')
        },
        //获取项目列表
        getSupplier (query, fun, ids = []) {
            query = query || '';
            this.$api.get('/admin/news/message/getprojectselect', { 'customer_id': this.addForm.supplier_id, 'query': query, 'public_id': ids }).then(res => {
                if (res.code === 0) {
                    this.options.execute_ids_options = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
            if (typeof fun === 'function') {
                fun();
            }
        },
        changeGetSupplier () {
            this.getSupplier('')
        },
        //获取发票录入下拉
        getInviocelrId (query, fun) {
            query = query || '';
            if (this.addForm.type == 1) {
                var nature_txt = '0,4'
            } else if (this.addForm.type == 2) {
                var nature_txt = '0,2'
            } else {
                var nature_txt = '0,2,4'
            }
            this.$api.get('/admin/news/message/getbanklineselect', { 'query': query, 'data_type': this.addForm.type, 'type': '0,1', 'nature': nature_txt }).then(res => {
                if (res.code === 0) {
                    this.options.invioce_lr_id_options = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
            if (typeof fun === 'function') {
                fun();
            }
        },
        //根据所选执行生成对应表格数据
        addExecuteIds () {
            if (this.addForm.type == 1) {
                this.$api.get('/admin/news/message/getprojectselect', { 'public_id': this.addForm.project_ids }).then(res => {
                    if (res.code === 0) {
                        const filteredOptions = res.data.filter(opt => this.addForm.project_ids.includes(opt.value));
                        this.collection_array = filteredOptions.map(item => ({ project_id: item.value, project_code: item.code, name: item.name, bank_statement_id: "", cost: "" }));
                        this.addForm.collection_array = filteredOptions.map(item => ({ project_id: item.value, project_code: item.code, name: item.name, bank_statement_id: "", cost: item.price }));
                        //获取申请收款界面可收款金额--------执行
                        if (this.addForm.project_ids.length > 0) {
                            this.$api.get('/admin/news/message/getapplycollectioncost', { type: this.addForm.type, project_ids: this.addForm.project_ids }).then(res => {
                                if (res.code === 0) {
                                    this.execute_tips = res.msg
                                } else {
                                    this.$message.error(res.msg);
                                }
                            })
                        } else {
                            this.execute_tips = ''
                        }
                    }
                })
            } else {
                this.$api.get('/admin/customers/customer/getexecuteselect', { 'public_id': this.addForm.project_ids, 'status': 'applycollection' }).then(res => {
                    if (res.code === 0) {
                        const filteredOptions = res.data.filter(opt => this.addForm.project_ids.includes(opt.value));
                        this.collection_array = filteredOptions.map(item => ({ project_id: item.value, project_code: item.code, name: item.name, bank_statement_id: "", cost: "" }));
                        this.addForm.collection_array = filteredOptions.map(item => ({ project_id: item.value, project_code: item.code, name: item.name, bank_statement_id: "", cost: item.price }));
                        //获取申请收款界面可收款金额--------执行
                        if (this.addForm.project_ids.length > 0) {
                            this.$api.get('/admin/news/message/getapplycollectioncost', { type: this.addForm.type, project_ids: this.addForm.project_ids }).then(res => {
                                if (res.code === 0) {
                                    this.execute_tips = res.msg
                                } else {
                                    this.$message.error(res.msg);
                                }
                            })
                        } else {
                            this.execute_tips = ''
                        }
                    }
                })
            }
        },
        //根据发票录入获取对应
        // this.addForm.collection_array[index].cost = ''
        getCost (index) {

            this.$nextTick(() => {
                this.$refs['addForm'].clearValidate(`collection_array[${index}].cost`);
            });
        },
        // 申请收款弹窗
        addInvoiceOpen () {
            this.addForm = {
                type: 1,
                supplier_id: '',
                project_ids: [],
                collection_array: [{
                    project_id: '',
                    bank_statement_id: '',
                    cost: '',
                    project_code: ''
                }],
                remark: ''
            }
            this.collection_array = []
            this.execute_tips = ''
            this.$nextTick(() => {
                this.$refs['addForm'].clearValidate();
            });
            // 获取客户下拉
            this.getSupplierSelect()
            this.getInviocelrId()
            this.addFormVisiable = true;
        },
        // 申请收款
        addInvoice (type) {
            if (this.addFormVisiableButton) return;
            this.addFormVisiableButton = true;
            this.addForm['submit_type'] = type
            this.$refs['addForm'].validate(function (valid) {
                if (valid) {
                    if (this.addForm['id']) {
                        this.$api.post('/admin/news/message/editapplyprojectcollection', this.addForm).then(res => {
                            if (res.code === 0) {
                                // 重新加载表格
                                this.handleSearch();
                                this.$message({
                                    showClose: true,
                                    message: '申请收款成功！',
                                    type: 'success'
                                });
                                this.addFormVisiable = false;

                            } else {
                                this.$message.error(res.msg);
                            }
                            this.addFormVisiableButton = false;
                        }).catch(() => {
                            this.addFormVisiableButton = false;
                        })
                    } else {
                        this.$api.post('/admin/news/message/applyprojectcollection', this.addForm).then(res => {
                            if (res.code === 0) {
                                // 重新加载表格
                                this.handleSearch();
                                this.$message({
                                    showClose: true,
                                    message: '申请收款成功！',
                                    type: 'success'
                                });
                                this.addFormVisiable = false;

                            } else {
                                this.$message.error(res.msg);
                            }
                            this.addFormVisiableButton = false;
                        }).catch(() => {
                            this.addFormVisiableButton = false;
                        })
                    }
                } else {
                    this.addFormVisiableButton = false;
                    this.$message({
                        showClose: true,
                        message: '请填写正确的信息！',
                        type: 'warning'
                    });
                }
            }.bind(this));
        },
        editConfirmForm (row) {
            // 获取收款信息单条详情
            this.$api.get('/admin/news/message/getcollectioninfo', { id: row.id }).then(res => {
                if (res.code === 0) {
                    this.addFormVisiable = true
                    this.$set(this.addForm, 'id', res.data.id)
                    this.$set(this.addForm, 'type', res.data.type)
                    this.$set(this.addForm, 'remark', res.data.remark)
                    this.$set(this.addForm, 'supplier_id', res.data.customer_id)

                    this.getInviocelrId('', () => {
                        if (res.data.type == 1) {
                            this.getSupplierSelect(res.data.customer_nname, () => {
                                this.$set(this.addForm, 'collection_array', res.data.collection_array)
                                this.$set(this, 'collection_array', res.data.collection_array)
                            })
                            this.getSupplier('', () => {
                                this.$set(this.addForm, 'project_ids', res.data.project_ids)
                            }, res.data.project_ids)
                        } else {
                            this.getSupplierSelectDown(res.data.customer_nname, () => {
                                this.$set(this.addForm, 'collection_array', res.data.collection_array)
                                this.$set(this, 'collection_array', res.data.collection_array)
                            })
                            this.getSupplierExecute('', () => {
                                this.$set(this.addForm, 'project_ids', res.data.project_ids)
                            }, res.data.project_ids)
                        }
                    })
                }
            });
        },
        addConfirmForm (row) {
            this.$api.post('/admin/news/message/confirmprojectcollection', { id: row.id }).then(res => {
                if (res.code === 0) {
                    var data = this.tableData.data;
                    data.forEach(function (item, index) {
                        if (row.id == item.id) {
                            this.$set(data[index], 'status_txt', '待审核');
                            this.$set(data[index], 'status', 2);
                        }
                    }.bind(this));
                    this.$message({
                        showClose: true,
                        message: '该申请已进入审批流程，等待审核！',
                        type: 'success'
                    });
                } else {
                    this.$message.error(res.msg);
                }
                this.loading = false
            })
        },
        //打开详情页
        detail (row) {
            this.$router.push({
                name: 'CollectionDetail',
                query: { id: row.id, set_id: 8, type: 'detail' }
            });
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            // 使用 === 进行严格相等判断
            if (from.path !== '/collectionDetail') {
                try {
                    vm.reset();
                } catch (error) {
                }
            }
        });
    }
}
</script>
<style type="text/css" scoped>
.el-table .el-form-item--mini.el-form-item,
.el-table .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>